/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteExchangeRateInput = {
    id?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteExchangeRateMutationVariables = {
    input: DeleteExchangeRateInput;
};
export type deleteExchangeRateMutationResponse = {
    readonly deleteExchangeRate: {
        readonly deletedExchangeRateId: string | null;
    } | null;
};
export type deleteExchangeRateMutation = {
    readonly response: deleteExchangeRateMutationResponse;
    readonly variables: deleteExchangeRateMutationVariables;
};



/*
mutation deleteExchangeRateMutation(
  $input: DeleteExchangeRateInput!
) {
  deleteExchangeRate(input: $input) {
    deletedExchangeRateId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteExchangeRateInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteExchangeRatePayload",
    "kind": "LinkedField",
    "name": "deleteExchangeRate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedExchangeRateId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteExchangeRateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteExchangeRateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteExchangeRateMutation",
    "operationKind": "mutation",
    "text": "mutation deleteExchangeRateMutation(\n  $input: DeleteExchangeRateInput!\n) {\n  deleteExchangeRate(input: $input) {\n    deletedExchangeRateId\n  }\n}\n"
  }
};
})();
(node as any).hash = '86274c0481673a3b32ea438f2020e826';
export default node;
